import { render, staticRenderFns } from "./ChatMessageList.vue?vue&type=template&id=36c4427f&scoped=true"
import script from "./ChatMessageList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ChatMessageList.vue?vue&type=style&index=0&id=36c4427f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c4427f",
  null
  
)

export default component.exports